import axios from 'axios';

export class AppService {
  static async getAllApplications() {
    await axios.get('api/applications').then(response => {
      // isso é uma gambiarra pra temporariamente resolver o problema em que
      // não aparece o nome do painel, apenas seu client_id
      const appsArray = [...response.data.results, {
        category: null,
        client_id: '6e19e8b91aa41d1911cf24ef4ae265e7',
        name: 'Painel de Pedidos',
        url: "http://ordersv2.plugg.to/"
      }];

      localStorage.setItem('apps', JSON.stringify(appsArray));
    });
  }

  static getNameOfAppByClientID(clientId) {
    const apps = JSON.parse(localStorage.getItem('apps'));
    if (apps) {
      let app = apps.filter((item) => (item.client_id === clientId));
      if (app && app.length) {
        return app[0].name;
      } else {
        return clientId;
      }
    } else {
      return clientId;
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/services/appService.js